import { State } from '@cemex/cmx-client-layout';
import { createFeatureSelector } from '@ngrx/store';
import * as fromCxSalesLocations from './cx-sales-location.reducer';

export const cxSalesLocationKey = 'cxSalesLocations';
export const reducers = fromCxSalesLocations.reducer;

export interface CxSalesLocationsState extends State {
  [cxSalesLocationKey]: fromCxSalesLocations.CxSalesLocationState;
}

export const selectSalesLocationsState =
  createFeatureSelector<fromCxSalesLocations.CxSalesLocationState>(cxSalesLocationKey);
